export interface ITwitterLogin {
    oauth_callback: string;
    oauth_consumer_key: string;
}
